var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"operations"},[_c('Breadcrumbs',{attrs:{"items":_vm.breadcrumbs}}),_vm._v(" "),_c('rp-table',{attrs:{"name":"operations","results":_vm.getOperations,"headings":['patient', 'hospital', 'surgeon', {heading: 'Surgery Date', key: 'performedAt'}]},on:{"rowClick":_vm.onRowClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4005f84e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Operations/Operations.vue
// module id = null
// module chunks = 